import { render, staticRenderFns } from "./custom copy.vue?vue&type=template&id=4862f568&scoped=true&"
import script from "./custom copy.vue?vue&type=script&lang=js&"
export * from "./custom copy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4862f568",
  null
  
)

export default component.exports